import { DstFilterEvent, DstMatTableDataSource, DstTableFilterMeta } from './dst-mat-table-data-source';

/**
 * PrimeNG p-table-compatible filter surface for migrated DST grids.
 * Wraps DstMatTableDataSource so callers can keep using table.filter(...).
 */
export class DstMatTableFilterApi<T> {
  constructor(private readonly dataSource: DstMatTableDataSource<T>) {}

  get filters(): Record<string, DstTableFilterMeta> {
    return this.dataSource.filters;
  }

  get filteredValue(): T[] {
    return this.dataSource.filteredValue;
  }

  get onFilter() {
    return this.dataSource.onFilter;
  }

  filter(value: any, field: string, matchMode: string): void {
    this.dataSource.applyColumnFilter(value, field, matchMode);
  }

  filterGlobal(value: string, matchMode: string): void {
    this.dataSource.applyGlobalFilter(value, matchMode);
  }

  reset(): void {
    this.dataSource.resetFilters();
  }
}

export type { DstFilterEvent };
